
    export default 
    {
    "chore": {
        "banner": {
            "content": "Scopri il viaggio che compiono i tuoi pacchi!",
            "learn_more": "SCOPRI DI PiÙ "
        }
    }
}